import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
// import HeadLogo from '../Assets/Oolook_logo.png'; // REMOVED: No longer used
import "react-toastify/dist/ReactToastify.css";

const ForgotPasswordConfirmation = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const email = localStorage.getItem("Email"); // Retrieve email to enable resend functionality

    const handleResendEmail = async () => {
        if (!email) {
            toast.error("Could not find your email. Please go back and try again.");
            navigate('/forgot-password');
            return;
        }

        setIsLoading(true);
        try {
            await axios.put(
                `${process.env.REACT_APP_BACKEND_API}/user/forgot_password`,
                { email_id: email }
            );
            toast.success('Another reset link has been sent! Please check your email.');
        } catch (err) {
            toast.error(err.response?.data?.message || 'Something went wrong. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <ToastContainer position="top-right" autoClose={5000} />
            <div className="auth-card auth-shell auth-confirmation-shell">
                <div className="auth-confirmation-icon" aria-hidden="true">
                    <i className="fa-regular fa-paper-plane"></i>
                </div>
                <h2 className="text-center text-2xl font-bold text-neutral-dark mb-2">Check Your Inbox!</h2>
                <p className="text-center text-sm text-neutral-muted mb-8">
                    We've sent a password reset link to <b className="text-neutral-dark">{email || "your email address"}</b>. Please check your spam folder if you don't see it.
                </p>
                
                <button
                    className="btn-primary"
                    onClick={() => navigate('/')}
                >
                    Back to Log In
                </button>

                <p className="text-sm text-center text-neutral-muted mt-6">
                    Didn’t receive the email?{' '}
                    <button
                        className="link"
                        onClick={handleResendEmail}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Sending...' : 'Click to resend'}
                    </button>
                </p>
            </div>
        </div>
    );
};

export default ForgotPasswordConfirmation;